import { useParams } from "react-router-dom";
import { isHash } from "../../utils";
import Extrinsic from "./extrinsic";
import OnChainExtrinsic from "./onChainExtrinsic";

export default function ExtrinsicRouter() {
  const { id } = useParams();

  // For hash-based IDs, use the regular Extrinsic component
  // which handles REST API calls properly
  if (isHash(id)) {
    return <Extrinsic />;
  }

  // For blockHeight-extrinsicIndex format, use OnChainExtrinsic
  return <OnChainExtrinsic />;
}
